module.exports = __webpack_public_path__ + "cn.ce4c8db3.svg";